import _ from 'lodash';

import $ from '~/qwery';
import bean from '~/bean';
import RadioGroup from '~/components/radio-group';
import ErrorTip from '~/components/error-tip';

export default class Validation {
    constructor(container) {
        this.$el = $(container);
        this._sels = [
            'input[type=text]',
            'input[type=password]',
            'input[type=email]',
            'textarea',
            '.b-radio-group',
        ];
        $(this._sels.join(', '), this.$el).each(field => {
            const $field = $(field);
            const errorTip = new ErrorTip($field);
            $field.data('error-tip', errorTip);
            bean.on($field[0], 'keyup change', e => {
                if (this._getFieldValue($field) != $field.data('error-value'))
                    bean.fire($field[0], 'non-error-value');
            });
            bean.on($field[0], 'non-error-value', () => {
                this._fieldErrorState($field, false);
                errorTip.hide();
            });
            bean.on($field[0], 'focus focus-first-error', () => {
                if (this._fieldErrorState($field))
                    errorTip.show();
            });
            bean.on($field[0], 'blur', () => {
                if (this._fieldErrorState($field))
                    errorTip.hide();
            });
        });
    }

    validate(filterFunc) {
        const $fields = $($(this._sels.join(', '), this.$el).toArray()
            .filter(f => {
                return f.offsetParent;   // true, if visible
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
            })
            .filter(filterFunc || (() => true)));
        this.errorFields = $fields.toArray()
            .map(field => {
                const $field = $(field);
                const vltr = (n, n2) => $field[0].getAttribute('data-' + n)
                    && (n2 ? JSON.parse($field.data(n))[n2]
                        : JSON.parse($field.data(n)));
                const hasVltr = (n, n2) => $field[0].getAttribute('data-' + n)
                    && (n2 == 'whole_digits' ? hasVltr(n, 'max_digits')
                        && hasVltr(n, 'decimal_places')
                    : n2 ? n2 in JSON.parse($field.data(n))
                    : true);
                const decVal = f => this._getFieldValue(f).replace('.', ',');
                const decimal = n => n == 'whole_digits'
                        && vltr('decimal', 'max_digits')
                        && vltr('decimal', 'decimal_places')
                            ?  vltr('decimal', 'max_digits')
                            - vltr('decimal', 'decimal_places')
                    : vltr('decimal', n);

                if (vltr('required')
                && ! this._getFieldValue(field)) {
                    return {$field: $field,
                        msg: $field.data('required-msg') || "Обов'язкове поле"};
                } else if (vltr('integer')
                && ! /^\s*(-|\+)?\d+\s*$/.test(this._getFieldValue(field))) {
                    return {$field: $field,
                        msg: $field.data('integer-msg') || 'Вкажіть ціле число'};
                } else if (hasVltr('min')
                && this._getFieldValue(field) < vltr('min')) {
                    return {$field: $field,
                        msg: $field.data('min-msg') || (vltr('min') == 1
                            ? 'Вкажіть додатне число'
                            : `Вкажіть число що більше або дорівнює ${vltr('min')}`)};
                } else if (hasVltr('max')
                && this._getFieldValue(field) > vltr('max')) {
                    return {$field: $field,
                        msg: $field.data('max-msg')
                            || `Вкажіть число що менше або дорівнює ${vltr('max')}`};
                } else if (hasVltr('maxlength')
                && this._getFieldValue(field).length > vltr('maxlength')) {
                    return {$field: $field,
                        msg: $field.data('maxlength-msg')
                            || `Максимальна довжина: ${vltr('maxlength')}`};

                } else if (hasVltr('decimal')
                && ! /^[-+]?\d*,?\d+$/.test(decVal(field))) {
                    return {$field: $field,
                        msg: $field.data('decimal-msg') || 'Вкажіть число'};
                } else if (hasVltr('decimal', 'max_digits')
                && decVal(field).replace(/\D+/g, '').length
                > decimal('max_digits')) {
                    return {$field: $field,
                        msg: $field.data('decimal-max-digits-msg')
                            || `Максимальна кількість цифр: ${decimal('max_digits')}`};
                } else if (hasVltr('decimal', 'decimal_places')
                && decVal(field).includes(',')
                && decVal(field).split(',')[1].length
                > decimal('decimal_places')) {
                    const dec_plcs = decimal('decimal_places');
                    const msg = `Максимальна кількість цифр після коми: ${dec_plcs}`;
                    return {$field: $field,
                        msg: $field.data('decimal-decimal-places-msg') || msg};
                } else if (hasVltr('decimal', 'whole_digits')
                && decVal(field).split(',')[0].replace(/\D+/g, '').length
                > decimal('whole_digits')) {
                    const whole_dgts = decimal('whole_digits');
                    const msg = `Максимальна кількість цифр до коми: ${whole_dgts}`;
                    return {$field: $field,
                        msg: $field.data('decimal-whole-digits-msg') || msg};
                }
            })
            .filter(field => field);
        if (this.errorFields.length) {
            this.errorFields.forEach(f => {
                this._fieldErrorState(f['$field'], true);
                f['$field'].data('error-value', this._getFieldValue(f['$field']));
                f['$field'].data('error-tip').msg(f['msg']);
            });
        }
        // unset error state for fields that are not to be validated this time
        $(this._sels.join(', '), this.$el).each(f => {
            if (this.errorFields.find(ef => {
                return f == ef['$field'][0];
            }))
                return;
            this._fieldErrorState(f, false);
        });
        if (this.errorFields.length) {
            if (this.errorFields[0]['$field'][0] == document.activeElement)
                // make error tip appear if pressing enter in the first invalid field
                bean.fire(this.errorFields[0]['$field'][0], 'focus-first-error');
            else
                this._focusField(this.errorFields[0]['$field']);
        }
        return ! this.errorFields.length;
    }

    getData() {
        return _.fromPairs(
            $(this._sels.join(', '), this.$el)
                .map(f => {
                    const name = f.name || f.getAttribute('name');
                    const value = this._getFieldValue(f);
                    return [name, value];
                }));
    }


    _isRadioGroupField(field) {
        return $(field).hasClass('b-radio-group');
    }

    _fieldErrorState(field, errorState) {
        const $field = $(field);
        if (this._isRadioGroupField($field))
            return new RadioGroup($field).errorState(errorState);
        if (errorState != null) {
            $field[errorState ? 'addClass' : 'removeClass']('has-error');
        }
        return $field.hasClass('has-error');
    }

    _getFieldValue(field) {
        const $field = $(field);
        if (this._isRadioGroupField($field))
            return new RadioGroup($field).value();
        else
            return $field.val().trim();
    }

    _focusField(field) {
        const $field = $(field);
        if (this._isRadioGroupField($field))
            new RadioGroup($field).focus();
        else
            $field[0].focus();
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/validation.js